import React, { useEffect, useRef } from 'react';
import { ToolbarButton } from './ConfigToolbar';

/**
 * ConfirmPopover — inline confirm anchored to a row action (delete/restore).
 * Parent wrapper must be `position: relative`.
 * props: { open, onClose, onConfirm, title, body, confirmLabel='Delete', danger=true, busy }
 */
export default function ConfirmPopover({ open, onClose, onConfirm, title, body, confirmLabel = 'Delete', danger = true, busy = false }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose && onClose(); };
    const onKey = (e) => { if (e.key === 'Escape') onClose && onClose(); };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDoc); document.removeEventListener('keydown', onKey); };
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="cp-pop" ref={ref} role="dialog" aria-label={title}>
      {title ? <div style={{ fontWeight: 600, color: 'var(--lodge-onyx-900)', marginBottom: 4 }}>{title}</div> : null}
      {body ? <div>{body}</div> : null}
      <div className="cp-pop-actions">
        <ToolbarButton small variant="ghost" onClick={onClose} disabled={busy}>Cancel</ToolbarButton>
        <ToolbarButton small variant={danger ? 'danger' : 'primary'} onClick={onConfirm} disabled={busy}>{busy ? 'Working…' : confirmLabel}</ToolbarButton>
      </div>
    </div>
  );
}
